import { useQuery } from '@tanstack/react-query';
import { listTrustedMcps } from '@kirin/api-client/api/system';
import type { TrustedMcpServersList } from '@kirin/api-client/contracts/trusted-mcps';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from './queryKeys';
import { retryHandlers } from './helpers';

/**
 * Hook to fetch the Kirin-managed list of trusted MCP server vendors.
 *
 * The list is release-time-immutable: identical for every authenticated
 * user, and only changes when a new backend version ships. We cache for
 * 5 minutes by default to avoid hammering the endpoint on tab focus
 * events while still picking up new entries within a single session
 * after a deploy.
 */
export function useTrustedMcpServers(
  enabled = true
): ReturnType<typeof useQuery<TrustedMcpServersList>> {
  return useQuery<TrustedMcpServersList>({
    queryKey: queryKeys.trustedMcps.list(),
    queryFn: () => listTrustedMcps(apiClient),
    staleTime: 5 * 60 * 1000,
    enabled,
    retry: retryHandlers.list,
  });
}
